<div class="wrapper" @fadeSlideInOut>
    <img class="image" src="/assets/img/intro.png" />
    <div class="text-block">
        <h3>{{ loginConfig?.loginTitle }}</h3>
        <div class="punchline">
            {{ loginConfig?.loginDescription }}
        </div>
        <hr />
    </div>
    <div class="provider-buttons">
        @for (provider of authProviders; track provider) {
        <button mat-flat-button color="primary" type="button" [disabled]="loginStatus === 'authenticating'" (click)="onProviderSelect(provider)" class="provider-button">
        {{ getProviderDisplayName(provider) }}
      </button> }
    </div>
    @if (loginStatus === "authenticating") {
    <mat-spinner class="spinner" diameter="40" color="primary"></mat-spinner>
    }
</div>